// import React from 'react';
// import { Link } from 'react-router-dom';  // For routing to project details page
// import { FaLongArrowAltRight } from 'react-icons/fa';  // For the "Know More" arrow icon
// import './Projects.css';
// import './Home.css';
// import DiscusForm from '../components/DiscussForm';

// // Import the JSON data (assuming the file is in the same directory or the correct path)
// // import projects from './projects.json';  // Adjust the path if needed
// import projects from '../data/ProjectsData';
// import { useEffect } from 'react';

// const Projects = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to top on page load
//   }, []);


//   return (
//     <div className='projects-main'>
//       {/* WAVE Hero */}
//       <div className='about-hero'>
//         <div className='about-hero-inner d-flex justify-content-center align-items-center'>
//           <div>
//             <h1 className='syne-title'>PROJECTS<span className='text-rose'>.</span></h1>
//             <p className='text-center'>Home / <span className='text-rose'>Projects</span></p>
//           </div>
//         </div>
//       </div>
//       {/* WAVE Hero */}
//       {/* Project cards */}
//       <div className='container-fluid py-4'>
//         <div className='container py-4'>
//           <div className="row">
//             {projects.map((project) => (
//               <div className="col-lg-4 col-md-6 my-3" key={project.id}>
//                 <div className="home-land-card h-100 shadow-sm">
//                   <img src={project.image} className="img-fluid home-land-card-img" alt={project.title} />
//                   {/* <h2>{project.image}</h2> */}
//                   <div className="home-land-card-content p-3 text-center bg-white">
//                     <h6 className="fw-bold">{project.title}</h6>
//                     <p className="mb-1">{project.location}</p>
//                     <div className="home-about-btn text-center">
//                       <Link to={`/projects/${project.id}`} className="text-rose">
//                         <FaLongArrowAltRight /> Know More
//                       </Link>

//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       {/* Project cards */}
//       {/* Home Discuss*/}

//       <DiscusForm />
//       {/* Home Discuss*/}
//     </div>

//   );
// };

// export default Projects;
// ////////////////////
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaLongArrowAltRight } from 'react-icons/fa';
import './Projects.css';
import './Home.css';
import DiscussForm from '../components/DiscussForm'; // Adjust path if needed

// Images for categories
import flatsImg from '../images/pro-categories/flats.jpg';
import villasImg from '../images/pro-categories/villa.jpg';
import plotsImg from '../images/pro-categories/plots.jpg';
import commercialsImg from '../images/pro-categories/commercials.jpeg';

const categoryData = [
  {
    title: 'Flats',
    link: '/projects/flats',
    image: flatsImg,
  },
  {
    title: 'Villas',
    link: '/projects/villas',
    image: villasImg,
  },
  {
    title: 'Plots',
    link: '/projects/plots',
    image: plotsImg,
  },
  {
    title: 'Commercial',
    link: '/projects/commercials',
    image: commercialsImg,
  },
];

const Projects = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='projects-main'>
      {/* Hero Section */}
      <div className='about-hero'>
        <div className='about-hero-inner d-flex justify-content-center align-items-center'>
          <div>
            <h1 className='syne-title'>PROJECTS<span className='text-rose'>.</span></h1>
            <p className='text-center'>Home / <span className='text-rose'>Projects</span></p>
          </div>
        </div>
      </div>

      {/* Category Cards */}
      <div className='container py-5'>
        <div className='row'>
          {categoryData.map((category, index) => (
            <div className='col-lg-3 col-md-6 my-3' key={index}>
              <Link to={category.link} className='text-decoration-none text-dark'>
                <div className='home-land-card h-100 shadow-sm text-center bg-white'>
                  <img src={category.image} alt={category.title} className='img-fluid' />
                  <div className='p-3'>
                    <h5 className='fw-bold'>{category.title}</h5>
                    <div className='text-rose'>
                      <FaLongArrowAltRight /> View Projects
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
``

      {/* Discuss Form */}
      <DiscussForm />
    </div>
  );
};

export default Projects;

